import { computed } from 'vue'
import { useUserStore } from '@/stores'

export default ({ maintenance, now }) => {
  const startsAtMs = computed(() => maintenance.value.startsAt ? Date.parse(maintenance.value.startsAt) : null)

  // The backend pushes no event when a scheduled window opens, so a passed
  // startsAt counts as active locally.
  const isActive = computed(() => maintenance.value.active || (startsAtMs.value !== null && startsAtMs.value <= now.value))
  const isScheduled = computed(() => !isActive.value && startsAtMs.value !== null)

  // Super Admin bearer tokens keep full API access during maintenance.
  const isBlocked = computed(() => isActive.value && !useUserStore().isSuperAdmin)

  return { isActive, isScheduled, isBlocked }
}
